<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Add MMF Dividend Calendar</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.close(false)"
  >
    Close
  </button>
</div>
<div class="modal-body" hsDraggable="modal-dialog">
  <form [formGroup]="mmfForm" class="mmfForm" *nfLoader="isSavingCalendar">
    <nf-form-control label="Calendar">
      <ng-select
        appendTo="body"
        formControlName="mmfDividendCalendarTypes"
        [items]="mmfDividendCalendarTypes"
        class="select-input"
        bindLabel="name"
        [closeOnSelect]="false"
      >
      </ng-select>
    </nf-form-control>
    <nf-form-control label="Date">
      <nf-datepicker
        id="dateRange"
        class="mb-0"
        formControlName="startDate"
        [format]="dateFormat"
        [placeholder]="dateFormat"
      ></nf-datepicker>
    </nf-form-control>

    <div *ngIf="duplicateCalendar" class="errorInfo">
      <span class="mdi mdi-alert-circle-outline text-danger genericIcon"></span>
      <span>Calendar already exists</span>
    </div>
  </form>
</div>

<div
  class="modal-footer d-flex justify-content-between"
  hsDraggable="modal-dialog"
>
  <div class="left-controls"></div>
  <div class="right-controls">
    <button nf-button="cancel" (click)="activeModal.close(false)">
      Cancel
    </button>
    <button
      nf-button="primary"
      (click)="saveCalendar()"
      type="submit"
      [disabled]="!mmfForm.valid"
    >
      Save
    </button>
  </div>
</div>
